<app-alert-message></app-alert-message>

<app-topo-geral *ngIf="!isLoggedIn"></app-topo-geral>
<app-topo-interno *ngIf="isLoggedIn"></app-topo-interno>

<router-outlet></router-outlet>

<app-footer-geral *ngIf="!isLoggedIn"></app-footer-geral>
<app-footer-interno *ngIf="isLoggedIn"></app-footer-interno>
